import { TipoTelefone } from './../../modelos/tipo-telefone';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Telefone } from './../../modelos/telefone';

@Component({
  selector: 'app-cadastro-telefone',
  templateUrl: './cadastro-telefone.component.html',
  styleUrls: ['./cadastro-telefone.component.css']
})
export class CadastroTelefoneComponent implements OnInit {

  @Output() telefoneEvent: EventEmitter<Telefone>;

  public telefone: Telefone;

  constructor(private modalService: NgbModal) {
    this.telefoneEvent = new EventEmitter<Telefone>();
  }

  cadastrar(content) {

	const ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false
	};

    this.telefone = new Telefone();
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
      this.telefoneEvent.emit(this.telefone);
    }, (reason) => {
    });
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/cadastro-telefone/cadastro-telefone.component.ts